import type { ConfigData } from '#lib/apps/types.js';
import { versionsStore } from '#lib/stores/versionsStore.svelte.js';
import { SC_DATASET } from '../layers';
import { isProgramsVersion, programVersionTag } from './programsVersion';

// Programs need both the server `work_programs` flag and a SafeCurves data version above the minimum.
export function programsEnabled(configData: ConfigData): boolean {
	return (
		configData.work_programs === true &&
		isProgramsVersion(versionsStore.version(SC_DATASET)?.version)
	);
}

// The selected SafeCurves version as a program version tag, or undefined before versions load.
export function activeProgramsVersion(): string | undefined {
	const series = versionsStore.version(SC_DATASET)?.series;
	return series ? programVersionTag(series) : undefined;
}
